import { Component, OnInit, ViewEncapsulation } from "@angular/core"; // Se elimina HostListener
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { User } from "src/app/core/models/users/user.models";
import { GruposService } from "src/app/core/services/groups/grupos.service";
import { LoginService } from "src/app/core/services/login";
import { MastersService } from "src/app/core/services/masters";
import { SocketService } from "src/app/core/services/socket/socket-service.service";
import { LocalStorage } from "src/app/core/utils";

@Component({
	selector: "app-modal-first-step-student",
	templateUrl: "./modal-first-step-student.component.html",
	styleUrls: ["./modal-first-step-student.component.scss"],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class ModalFirstStepStudentComponent implements OnInit {

	selectedGroupInfo: any = null;
	listeningActivitiesSubscription: Subscription;
	user: User;
	private subscriptions: Subscription[] = [];

	constructor(
		public translateService: TranslateService,
		private activeModal: NgbActiveModal,
		private masterService: MastersService,
		private localStorage: LocalStorage,
		public loginService: LoginService,
		private socketService: SocketService,
		private groupService: GruposService
	) { }

	ngOnInit() {
		this.user = this.loginService.getUser();
		this.localStorage.setItem("firstStepStudent", "true");
		this.crearLog();
		localStorage.removeItem("selectedGroupInfo");
	}

	enClase() {
		this.activeModal.close("clase");
		this.localStorage.removeItem("firstStepStudent");
	}

	estudiando() {
		this.activeModal.close("estudiando");
		this.localStorage.removeItem("firstStepStudent");
	}

	closeModal(sendData?: any) {
		this.activeModal.close("");
		this.localStorage.removeItem("firstStepStudent");
	}

	crearLog() {
		//*** Creamos el log ***
		this.masterService.createActivityHistory(
			"menu estudiantes",
			"Ha entrado en el primer menú de Estudiantes",
		);
		/*** Fin del log ***/
	}
}
